<template>
  <div class="special-list">
    <div :key="index" class="special-box" v-for="(item, index) in dataList">
      <div @click="jump(item)" class="special-box-image">
        <!-- <el-image :src="require('../../assets/image/resource/pic-audio.jpg')" fit="fill"></el-image> -->
        <el-image :src="item.coverPicture == '/'?require('../../assets/image/resource/pic-audio.jpg'):item.coverPicture" fit="fill"></el-image>
      </div>
      <div class="special-box-text">
        <div class="text-header">
          <div class="header-category">音频</div>
          <div class="header-title">{{item.title}}</div>
        </div>
        <div class="row-bg">
          <el-row class="row-bg">
            <!-- <el-col :span="12" v-show="item.clcno">
                <span class="item-explain">中国分类号</span>:
                <span class="item-content"> {{item.clcno}}</span>
            </el-col>
            <el-col :span="12" v-show="item.booknumber">
                <span class="item-explain">书号</span>:
                <span class="item-content">{{item.booknumber}}</span>
            </el-col>
            <el-col :span="12" v-show="item.publication">
                <span class="item-explain"> 出版发行</span>:
                <span class="item-content"> {{item.publication}}</span>
            </el-col>
            <el-col :span="12" v-show="item.originalbookprice">
                <span class="item-explain">原定书价</span>:
                <span class="item-content"> {{item.originalbookprice}}</span>
            </el-col> -->
            <el-col :span="24" v-show="item.introduction">
              <div>
                <span class="item-explain">简介</span>:
                <span class="item-content">
                                {{item.introduction}}
                  <!-- 《顿造忙(创世经)》为壮语南部方言民间信仰经典，在形式上是以殡葬礼仪来谈论创世的故事，其内容主要反映壮族及其先民对开天辟地、人类繁行、开垦拓围、筑城建州、土官分封、领主制度、生息企求等的认知思维及生活理念，展现想象中的世界图式，折射壮族地区社会发展的历史印迹;融神话、故事、歌谣、祭词等于一体，充满浓厚的壮乡生活气息和南国边疆文化色彩，对研究我国南方民族迁徙史、土司制度兴嘉史、民族文化交流史及壮族方 -->
                            </span>
              </div>
            </el-col>
          </el-row>
        </div>

        <div @click="jump(item)" class="text-button">
          <svg class="icon" height="18" p-id="3216" t="1644203588284" version="1.1" viewBox="0 0 1024 1024" width="18" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M996.955405 145.54762c-1.815156-0.265292-18.696111-2.59707-48.78582-2.59707-56.241924 0-155.614757 8.377645-283.178365 52.30443 131.040331-74.211972 265.208316-80.983902 267.037436-80.983902a20.609007 20.609007 0 0 0-1.661566-41.190088c-8.531235 0.349069-167.134019 7.986688-313.882435 102.877481 110.975871-103.589581 273.278781-134.977824 275.415081-135.438594a20.650895 20.650895 0 0 0 16.517924-24.001954C905.862478 2.680846 881.204276 0.600398 884.443632 0c-11.826442 2.178188-272.008172 52.262542-372.567838 244.278167C411.106687 52.70935 151.399691 2.666884 139.615137 0.474733a20.609007 20.609007 0 0 0-7.442141 40.491951c2.164225 0.40492 164.760352 31.667498 275.722261 135.620111C261.035139 81.556374 102.181027 73.876867 93.649791 73.541761a20.609007 20.609007 0 1 0-1.647603 41.190088c1.843082 0.083776 136.192583 6.604377 267.442355 81.137492-127.745124-44.010562-227.243622-52.444058-283.541396-52.444058-30.089708 0-46.998589 2.359703-48.869596 2.624996A30.941436 30.941436 0 0 0 0.685857 178.960461l51.341001 684.900407a30.969361 30.969361 0 0 0 29.74064 28.609658c254.359266 9.11767 409.946097 124.142737 411.481999 125.273719a30.91351 30.91351 0 0 0 32.393561 3.029915 30.508591 30.508591 0 0 0 7.274588-5.04055c19.226695-13.683487 169.745051-115.192619 409.3457-123.75178a30.955398 30.955398 0 0 0 29.726677-28.595695l51.313076-684.91437a30.955398 30.955398 0 0 0-26.361657-32.924145zM480.920396 937.05356c-65.443371-36.680123-193.090755-93.55037-369.300556-105.027743L64.677102 205.433819c3.448797-0.083776 7.162887-0.167553 11.170194-0.167553 71.209983 0 216.939118 14.437475 405.087063 108.909386z m431.44872-105.502476c-176.209801 11.379635-303.857186 68.347621-369.314519 105.01378V313.756769c188.147945-94.56965 333.905006-108.909386 405.114988-108.909385q5.990016 0 11.170194 0.125665z m0 0"
              p-id="3217">

            </path>
          </svg>
          <div>
            在线试听
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'PortalIndex',
    props: {
      dataList: {
        type: Array,
        required: true,
        default: () => []
      }
    },
    data() {
      return {};
    },

    mounted() {

    },

    methods: {
      jump(item) {
        this.$router.push({
          path: '/resource/detailsAud',
          query: {
            bookId: item.id
          }
        })
      }
    },
  };
</script>

<style lang="less" scoped>
  .special-list {
    .special-box {
      width: 47.188rem;
      min-height: 11.563rem;
      border: 1px solid #e8e8e8;
      margin-bottom: 1.042rem;
      display: flex;
      padding-left: 2.188rem;
      padding-right: 1.188rem;
      padding-top: 1.198rem;
      padding-bottom: 1.094rem;

      .special-box-image {
        margin-right: 1.042rem;
        width: 13.333rem;
        height: 8.802rem;
        position: relative;
        cursor: pointer;

        .el-image {
          position: relative;
          width: 13.333rem;
          height: 8.802rem;
        }

        .el-image::after {
          content: '';
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          background: url('../../assets/image/resource/video_logo.png') no-repeat;
          z-index: 2;
          width: 50px;
          height: 50px;
          opacity: .6;
        }

        .el-image::before {
          content: '';
          position: absolute;
          box-shadow: inset 0 0 300px 100px #000;
          width: 100%;
          height: 100%;
          opacity: .6;
        }
      }

      .special-box-image:hover {
        .el-image::after {
          opacity: 1;
        }

        .el-image::before {
          opacity: .7;
        }
      }
    }

    .special-box:last-child {
      margin-bottom: 0px;
    }

    .special-box-text {
      position: relative;

      .text-header {
        display: flex;
        align-items: center;
        margin-bottom: 0.833rem;

        .header-category {
          width: auto;
          height: 1.342rem;
          line-height: 1.342rem;
          background-color: #5fb878;
          border-radius: 7px;
          color: #fff;
          padding: 0 0.3rem;
          font-size: 0.8rem;
          margin-right: 0.26rem;
        }
      }

      .row-bg {
        font-size: 0.725rem;
        min-height: 6rem;
        margin-bottom: 0.5rem;
        line-height: 1.8;
      }

      .text-button {
        // position: absolute;
        align-items: center;
        bottom: 0rem;
        font-size: 0.625rem;
        width: 5.479rem;
        display: flex;
        padding: 4px 12px;
        border-radius: 5px;
        border: 1px solid #dcdfe6;
        cursor: pointer;

        svg {
          margin-right: 0.3rem;
        }
      }

      .text-button:hover {
        color: #fff;
        background-color: #b2262f;
        border-color: #b2262f;

        svg {
          path {
            fill: #fff !important;
          }

        }
      }
    }

  }
</style>
